// extracted by mini-css-extract-plugin
module.exports = {"root":"UsageBadge_root__3wHUT","public":"UsageBadge_public__3LU71","api":"UsageBadge_api__3xBRT"};